import Blob from 'cross-blob';

// The File constructor is not available in Node.js
const FileShim: typeof File =
  typeof File !== 'undefined'
    ? File
    : class File extends Blob {
        name: string;
        lastModified: number;
        webkitRelativePath: string;

        constructor(fileBits: BlobPart[], fileName: string, options?: FilePropertyBag) {
          super(fileBits, options);

          this.name = fileName;
          this.lastModified = options?.lastModified ?? Date.now();
          this.webkitRelativePath = fileName;
        }
      };

export default FileShim;
